export const ConvertToMoney = (value, currency = 'COP') => {
    if (isNaN(value)) {
        return value;
    } else {
        switch (currency) {
            case 'COP':
                return Intl.NumberFormat('es-co', {
                    style: 'currency',
                    currency: 'COP',
                    currencyDisplay: 'narrowSymbol',
                }).format(value);
            case 'MXN':
                return Intl.NumberFormat('es-mx', {
                    style: 'currency',
                    currency: 'MXN',
                    currencyDisplay: 'narrowSymbol',
                }).format(value);
            default:
                return value;
        }
    }
}